module.exports = {
  STANDARD: 0,
  HOMECALL: 1,
  REVERSE_IT: 2,
  REVERSE_IT_RECEIPT: 3,
  SWAP_IT: 4,
  SWAP_IT_RECEIPT: 5,
  INTERNATIONAL_EXPORT: 6,
  SMALL_SORT: 7,
};
